import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceOperationStatus.css';
import Modal from '../Modal/Modal';
import CustomButton from '../CustomElements/CustomButton';
import TransferDeviceFromOperationToStorage from './TransferDeviceFromOperationToStorage';
import EditOperationSendStatus from './EditUsageSendStatus';
import useModalWithStatus from '../../customHook/useModalWithStatus';
import EditOperationSendUippsStatus from './EditUsageSendUippsStatus';
import TableMap from './TableMap';
// Кастомные хуки
import useDeviceStatus from '../../customHook/useDeviceStatus';
import { useRole } from '../../customHook/useRole';
// Действия Redux
import { initStatusesFromServer } from '../../redux/actions/statuses.action';
import { STATUS } from '../../constants/status';

// компонент для отображения таблицы статусов эксплуатации устройства
// и обработки действий с ними.

function DeviceUsageStatus({ currentDevice, setActiveButton, activeButton, uippsType, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  //проверяем роли пользователя
  const isMaster = useRole('master');

  //получаем массив статусов Хранение из стора
  const { usageStatuses } = useSelector((state) => state?.statuses);

  // Получаем id статуса текущего устройства
  const deviceStatusId = currentDevice?.statusId;
  // Кнопка отключена, если статус не "Эксплуатация" (USAGE = 10)
  const disabledBtn = deviceStatusId !== STATUS.USAGE;

  const [statusId, setStatusId] = useState('');

  // хук для получения текущего статуса по id
  const currentStatus = useDeviceStatus(usageStatuses, statusId);

  const title = t?.deviceEditStatusTitle || 'ИЗМЕНЕНИЕ ДАННЫХ СТАТУСА';

  // Хук для управления модальным окном статусов
  const { isOpen, activeModal, closeModal, handleButtonClick } = useModalWithStatus(
    usageStatuses,
    currentDevice,
    setStatusId,
    t
  );
  const contentData = {
    [t?.statusIssueOperation || 'Выдача']: uippsType ? (
      <EditOperationSendUippsStatus
        key={currentStatus?.id || 'new'}
        currentDevice={currentDevice}
        currentStatus={currentStatus}
        closeModal={closeModal}
        title={title}
        isEdit={true}
        t={t}
      />
    ) : (
      <EditOperationSendStatus
        currentDevice={currentDevice}
        currentStatus={currentStatus}
        closeModal={closeModal}
        title={title}
        isEdit={true}
        t={t}
      />
    ),
    [t?.statusReturnOperation || 'Возврат']: (
      <TransferDeviceFromOperationToStorage
        currentDevice={currentDevice}
        currentStatus={currentStatus}
        closeModal={closeModal}
        title={title}
        isEdit={true}
        t={t}
      />
    ),
    [t?.statusReceiveForStorage || 'Принять на хранение']: (
      <TransferDeviceFromOperationToStorage currentDevice={currentDevice} closeModal={closeModal} t={t} />
    ),
  };
  // Инициализации статусов с сервера. принимает id устройства и тип статусов
  useEffect(() => {
    dispatch(initStatusesFromServer(currentDevice.id, 'usage'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Таблица со статусами */}
      {usageStatuses && (
        <TableMap
          data={usageStatuses}
          handleButtonClick={handleButtonClick}
          currentDevice={currentDevice}
          setActiveButton={setActiveButton}
          activeButton={activeButton}
          t={t}
        />
      )}
      {/* Блок с кнопками */}
      {!isMaster && (
        <div className="device-operation-status_button-container">
          <CustomButton
            className="device-operation-status_button"
            text={t?.buttonStorage || 'Принять на хранение'}
            colorText="#FFFFF"
            onClick={() => handleButtonClick(t?.buttonStorage || 'Принять на хранение')}
            color={disabledBtn ? '#ADADAD' : ''}
            disabled={disabledBtn}
          />
        </div>
      )}
      {/* Модальное окно */}
      {isOpen && (
        <Modal isOpen={isOpen} onClose={closeModal} containerSelector={'.table-for-devices_or_uipps_container'}>
          {contentData[activeModal]}
        </Modal>
      )}
    </>
  );
}

export default DeviceUsageStatus;
